import HeroTitle from '#app/components/titles/hero-title.tsx'
import { useTranslation } from 'react-i18next'

export default function OurStoryRoute() {
	const {t} = useTranslation();
	return (
		<div className="container flex max-w-6xl flex-col justify-center pb-48 pt-12 text-black">
			<div className="rounded-xl bg-white">
				<div className="mx-auto mb-16 max-w-7xl px-6 lg:px-8">
					<HeroTitle
						title={t('aboutUs.index.ourStory.title')}
						subject={t('aboutUs.index.ourStory.subject')}
						description={t('aboutUs.index.ourStory.description')}
					/>
					<div className="mt-10 text-center">
						<img src="/img/building2.png" alt="office" className="rounded-xl" />
					</div>
					<div className="mt-20 sm:flex sm:max-w-5xl sm:justify-between sm:gap-60">
						<div className="whitespace-nowrap">
							<h3 className="text-h3">{t('aboutUs.index.ourStory.howItStarted.title')}</h3>
						</div>
						<div className="mt-10 flex flex-col gap-10 font-proxima sm:mt-0">
							<div>
								{t('aboutUs.index.ourStory.howItStarted.content.0')}
							</div>
							<div>
								{t('aboutUs.index.ourStory.howItStarted.content.1')}
							</div>
							<div>{t('aboutUs.index.ourStory.howItStarted.content.2')}</div>
						</div>
					</div>
					{/*<div className="container mx-auto py-20">*/}
					{/*    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">*/}
					{/*        <div className="flex justify-center items-center bg-gray-200 rounded p-4">*/}
					{/*            <img src="/img/team/joyce.png" alt="Joyce" className="max-w-full h-auto rounded"/>*/}
					{/*        </div>*/}
					{/*        <div className="flex justify-center items-center bg-gray-200 rounded p-4">*/}
					{/*            <img src="/img/team/weijia2.png" alt="Weijia" className="max-w-48 h-auto rounded"/>*/}
					{/*        </div>*/}
					{/*        <div className="flex justify-center items-center bg-gray-200 rounded p-4">*/}
					{/*            <img src="/img/team/victoria.png" alt="Victoria" className="max-w-48 h-auto rounded"/>*/}
					{/*        </div>*/}
					{/*        <div className="flex justify-center items-center bg-gray-200 rounded p-4">*/}
					{/*            <img src="/img/team/ivo.png" alt="Ivo" className="max-w-full h-auto rounded"/>*/}
					{/*        </div>*/}
					{/*        <div className="flex justify-center items-center bg-gray-200 rounded p-4">*/}
					{/*            <img src="/img/team/matt.jpg" alt="Matt" className="max-w-48 h-auto rounded"/>*/}
					{/*        </div>*/}
					{/*        <div className="flex justify-center items-center bg-gray-200 rounded p-4">*/}
					{/*            <img src="/img/team/mike.png" alt="Mike" className="max-w-48  h-auto rounded"/>*/}
					{/*        </div>*/}
					{/*    </div>*/}
					{/*</div>*/}

					<div className="mt-36 sm:flex sm:max-w-5xl sm:justify-between sm:gap-60">
						<div className="whitespace-nowrap">
							<h3 className="font-proxima text-h3">{t('aboutUs.index.ourStory.howIsItGoing.title')}</h3>
						</div>
						<div className="mt-10 flex flex-col gap-10 font-proxima sm:mt-0">
							<div>
								{t('aboutUs.index.ourStory.howIsItGoing.content.0')}
							</div>
							<div>
								{t('aboutUs.index.ourStory.howIsItGoing.content.1')}
							</div>
							<div>
								{t('aboutUs.index.ourStory.howIsItGoing.content.2')}{' '}
								<a href="https://dashboard.refundr.ca/signup" target="_blank" className="text-neutral-900 underline underline-offset-2">
									{t('aboutUs.index.ourStory.howIsItGoing.links.dashboard')}
								</a>{' '}
								{t('aboutUs.index.ourStory.howIsItGoing.content.3')}{' '}
								<a
									href="https://calendly.com/refundr-michael/30min"
									target="_blank"
									className="text-neutral-900 underline underline-offset-2"
								>
									{t('aboutUs.index.ourStory.howIsItGoing.links.bookCall')}
									{/*Take a Quick Tour*/}

								</a>{' '}
								{t('aboutUs.index.ourStory.howIsItGoing.content.4')}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
